import React, { useState } from 'react';
import Layout from './components/Layout';
import ResponsiveShadow from './components/ResponsiveShadow';
import Sidebar from './components/Sidebar';
import LoadingModal from './components/modals/LoadingModal';
import { relatoriosGlobais, triggerReport } from './utils/relatoriosGlobais';
import { useSidebar } from './context/SidebarContext';

const Relatorios = () => {
  const { isSidebarOpen, toggleSidebar, sidebarRef } = useSidebar();
  const [loading, setLoading] = useState(false);

  const handleGerarRelatorio = async (report) => {
    setLoading(true);
    try {
      // Chamar triggerReport sem passar navigate (agora usa localStorage e eventos)
      await triggerReport(report);
    } catch (error) {
      console.error('Erro ao gerar relatório:', error);
      alert('Erro ao gerar relatório: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <LoadingModal loading={loading} />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          sidebarRef={sidebarRef}
        />

        {/* Conteúdo principal */}
        <div
          className="content"
          style={{
            marginLeft: isSidebarOpen ? '200px' : '50px',
            transition: 'margin-left 0.3s ease-in-out',
            padding: '20px',
            width: '100%',
          }}
        >
          <div className="container mt-4 pt-3">
            <ResponsiveShadow className="mb-4 px-3 py-3">
              <h3 className="mb-4">
                <i className="bi bi-file-earmark-text me-2"></i>
                Relatórios
              </h3>
              
              <div className="row">
                {relatoriosGlobais.filter(r => !r.hidden).map((relatorio, index) =>
                  relatorio.submenu ? (
                    <React.Fragment key={index}>
                      <div className="col-12 mb-2 mt-3">
                        <h5 className="text-secondary border-bottom pb-1">
                          <i className={relatorio.icon}></i>
                          {relatorio.label}
                        </h5>
                      </div>
                      {relatorio.submenu.map((sub, subIndex) => (
                        <div key={`sub-${index}-${subIndex}`} className="col-md-6 col-lg-4 mb-3">
                          <div className="card h-100 shadow-sm">
                            <div className="card-body">
                              <h5 className="card-title">
                                <i className={sub.icon}></i>
                                {sub.label}
                              </h5>
                              {sub.tooltip && (
                                <p className="card-text text-muted small">{sub.tooltip}</p>
                              )}
                              <button
                                className="btn btn-primary btn-sm w-100"
                                onClick={() => handleGerarRelatorio(sub)}
                                disabled={loading || !sub.action}
                              >
                                {loading ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Gerando...
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-file-pdf me-2"></i>
                                    Gerar Relatório
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </React.Fragment>
                  ) : (
                    <div key={index} className="col-md-6 col-lg-4 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-body">
                          <h5 className="card-title">
                            <i className={relatorio.icon}></i>
                            {relatorio.label}
                          </h5>
                          {relatorio.tooltip && (
                            <p className="card-text text-muted small">
                              {relatorio.tooltip}
                            </p>
                          )}
                          <button
                            className="btn btn-primary btn-sm w-100"
                            onClick={() => handleGerarRelatorio(relatorio)}
                            disabled={loading || !relatorio.action}
                          >
                            {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Gerando...
                              </>
                            ) : relatorio.action ? (
                              <>
                                <i className="bi bi-file-pdf me-2"></i>
                                Gerar Relatório
                              </>
                            ) : (
                              <>
                                <i className="bi bi-tools me-2"></i>
                                Em Construção
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </ResponsiveShadow>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Relatorios;